import UserListComponent from 'src/components/features/superAdmin/userListComponent';

const ListUserPage = () => <UserListComponent />;

export default ListUserPage;
